import"./ProductFeatures.css.ts.vanilla.css";var e="me14081",r="me14082",t="me14080",a="me14083";export{e as featureContainer,r as featureCopy,t as productFeaturesContainer,a as svg};
